import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/blogs';
import './Blogs.css';

const Blogs: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-page">
      <div className="blogs-container">
        
        <div className="blogs-header">
          <h1 className="blogs-title">Industrybull <span>Blogs</span></h1>
          <p className="blogs-subtitle">
            Insights, guides, and news from the industrial world.
          </p>
        </div>

        <div className="blogs-grid">
          {blogPosts.map((post) => (
            <div key={post.id} className="blog-card">
              <Link to={`/blogs/${post.id}`} className="blog-card__image-container">
                <span className="blog-card__placeholder"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></span>
                <span className="blog-card__category-badge">{post.category}</span>
              </Link>
              
              <div className="blog-card__content">
                <div className="blog-card__meta">
                  <span>{post.date}</span>
                  <span className="blog-card__meta-separator">•</span>
                  <span style={{ textTransform: 'capitalize' }}>By {post.author}</span>
                </div>
                
                <h3 className="blog-card__title">
                  <Link to={`/blogs/${post.id}`}>{post.title}</Link>
                </h3>
                
                <p className="blog-card__snippet">{post.snippet}</p>
                
                <div className="blog-card__footer">
                  <Link to={`/blogs/${post.id}`} className="blog-card__read-more">
                    Read Article
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="blogs-pagination">
          <Link to="#" className="blogs-pagination__btn disabled">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="blogs-pagination__icon">
              <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" fill="currentColor"/>
            </svg>
          </Link>
          <Link to="#" className="blogs-pagination__btn active">1</Link>
          <Link to="#" className="blogs-pagination__btn">2</Link>
          <Link to="#" className="blogs-pagination__btn">3</Link>
          <span style={{ color: '#9CA3AF', margin: '0 4px' }}>...</span>
          <Link to="#" className="blogs-pagination__btn">61</Link>
          <Link to="#" className="blogs-pagination__btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="blogs-pagination__icon">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" fill="currentColor"/>
            </svg>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Blogs;
